import React from 'react';
import '../App.css';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const Carrito = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <section className="carrito-page">
        <h2>Carrito de Compras</h2>
        <div className="carrito-msg">
          Debes iniciar sesión para ver y comprar productos.
          <button className="carrito-login-btn" onClick={() => navigate('/login')}>Iniciar sesión</button>
        </div>
      </section>
    );
  }

  return (
    <section className="carrito-page">
      <h2>Carrito de Compras</h2>
      {/* Placeholder para productos en el carrito */}
      <div className="carrito-productos-placeholder">
        <div className="carrito-producto-card">Producto en carrito 1</div>
        <div className="carrito-producto-card">Producto en carrito 2</div>
      </div>
      {/* Placeholder para resumen y checkout */}
      <div className="carrito-resumen-placeholder">
        <div className="carrito-total">Total: $0.00</div>
        <button className="carrito-checkout-btn">Ir a pagar</button>
      </div>
    </section>
  );
};

export default Carrito; 